import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  multiSelectDropdown: false,
  dropdown: false,
  calendar: false,
};

const toggleDropdownSlice = createSlice({
  name: "toggleDropdown",
  initialState,
  reducers: {
    toggleMultiSelectDropdown: (state, action) => {
      let { val } = action.payload;
      state.multiSelectDropdown = val;
    },
    toggleNormalDropdown: (state, action) => {
      let { val } = action.payload;
      state.dropdown = val;
    },
    toggleCalendar: (state, action) => {
      let { val } = action.payload;
      state.calendar = val;
    },
  },
});

export const {
  toggleMultiSelectDropdown,
  toggleNormalDropdown,
  toggleCalendar,
} = toggleDropdownSlice.actions;

export default toggleDropdownSlice.reducer;
